(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var container = document.getElementById('elqora-combo');
    if (!container) return;

    var productHandle = container.getAttribute('data-product-handle');
    if (!productHandle) {
      container.innerHTML = '<p class="elqora-combo-error is-visible">Configuration Error: Product handle is missing.</p>';
      return;
    }

    var apiUrl = 'https://shop.elqoracosmetics.com/api/combos-new/combo-listing?handle=' + encodeURIComponent(productHandle);
    container.innerHTML = '<p class="elqora-combo-loading">Loading dynamic combo builder...</p>';

    fetch(apiUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('API server returned status ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.success || !data.offer) {
          throw new Error(data.message || 'Invalid combo payload returned.');
        }

        var offer = data.offer;
        var products = offer.includedProducts || [];

        if (!products.length) {
          throw new Error('No items found matching this combo offer.');
        }

        populateDynamicGallery(products);
        renderDynamicCombo(container, products, offer);
      })
      .catch(function (err) {
        console.error('[Dynamic Combo Load Error]:', err);
        container.innerHTML = '<p class="elqora-combo-error is-visible">' + (err.message || 'Unable to load combo options right now.') + '</p>';
      });
  });

  function getProductMainImage(product) {
    if (!product) return '';
    if (Array.isArray(product.images) && product.images.length > 0) {
      var first = product.images[0];
      return typeof first === 'string' ? first : (first.url || first.src || '');
    }
    if (product.featuredImage) {
      return typeof product.featuredImage === 'string' ? product.featuredImage : (product.featuredImage.url || '');
    }
    return '';
  }

  function getProductSwatchImage(product) {
    if (!product) return '';
    if (Array.isArray(product.images) && product.images.length >= 6) {
      var sixth = product.images[5];
      return typeof sixth === 'string' ? sixth : (sixth.url || sixth.src || '');
    }
    return getProductMainImage(product);
  }

  var galleryThumbsByProductId = {};
  var mainImageEl = null;

  function populateDynamicGallery(products) {
    var thumbsContainer = document.getElementById('elqora-combo-thumbnails');
    mainImageEl = document.getElementById('elqora-combo-main-image');
    if (!thumbsContainer) return;

    thumbsContainer.innerHTML = '';
    galleryThumbsByProductId = {};

    products.forEach(function (product, pIndex) {
      var rawImages = (Array.isArray(product.images) && product.images.length) ? product.images : [getProductMainImage(product)];
      galleryThumbsByProductId[product.id] = [];

      rawImages.forEach(function (image, imgIndex) {
        var imgUrl = typeof image === 'string' ? image : (image.url || image.src || '');
        if (!imgUrl) return;

        var thumb = document.createElement('div');
        thumb.className = 'elqora-combo-gallery-thumb' + (pIndex === 0 && imgIndex === 0 ? ' active' : '');
        thumb.setAttribute('data-combo-thumb', '');
        thumb.setAttribute('data-product-id', String(product.id));

        var img = document.createElement('img');
        img.src = imgUrl;
        img.alt = product.title || 'Product Image';
        img.loading = 'lazy';
        thumb.appendChild(img);

        thumb.addEventListener('click', function () {
          setActiveThumb(thumb, imgUrl, product.title);
        });

        thumbsContainer.appendChild(thumb);
        galleryThumbsByProductId[product.id].push(thumb);
      });
    });

    if (products[0]) activateGalleryThumb(products[0]);
  }

  function setActiveThumb(thumb, imageUrl, altText) {
    if (mainImageEl && imageUrl) {
      mainImageEl.src = imageUrl;
      mainImageEl.alt = altText || '';
    }
    document.querySelectorAll('[data-combo-thumb]').forEach(function (t) { t.classList.remove('active'); });
    if (thumb) thumb.classList.add('active');
  }

  function activateGalleryThumb(product) {
    if (!product || !galleryThumbsByProductId[product.id]) return;
    var thumbs = galleryThumbsByProductId[product.id];
    if (!thumbs || !thumbs.length) return;
    var firstThumb = thumbs[0];
    var firstImg = firstThumb.querySelector('img');
    setActiveThumb(firstThumb, firstImg ? firstImg.src : '', product.title);
  }

  function parseShadeLabel(title) {
    if (!title) return '';
    var parts = String(title).split(',');
    return parts.length > 1 ? parts[parts.length - 1].trim() : title;
  }

  function parseBrandLabel(title) {
    if (!title) return '';
    var parts = String(title).split('|');
    return parts[0] ? parts[0].trim() : title;
  }

  function renderDynamicCombo(container, products, offer) {
    var slotCount = parseInt(offer.slotCount, 10) || 3;
    var comboPrice = parseFloat(offer.comboPrice) || 0;
    var offerTitle = offer.title || 'Combo Set';

    var selections = [];
    for (var i = 0; i < slotCount; i++) {
      selections.push(i % products.length);
    }

    var wrap = document.createElement('div');
    wrap.className = 'elqora-combo';

    var heading = document.createElement('h3');
    heading.className = 'elqora-combo-heading';
    heading.textContent = offerTitle;
    wrap.appendChild(heading);

    var slotsWrap = document.createElement('div');
    slotsWrap.className = 'elqora-combo-slots';
    wrap.appendChild(slotsWrap);

    var addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.className = 'elqora-combo-add-btn';
    wrap.appendChild(addBtn);

    var errorEl = document.createElement('p');
    errorEl.className = 'elqora-combo-error';
    wrap.appendChild(errorEl);

    function renderSlot(slotIndex) {
      var selectedProduct = products[selections[slotIndex]];
      var slotEl = document.createElement('div');
      slotEl.className = 'elqora-combo-slot';

      var info = document.createElement('div');
      info.className = 'elqora-combo-slot-info';

      var thumb = document.createElement('img');
      thumb.className = 'elqora-combo-slot-thumb';
      thumb.src = getProductMainImage(selectedProduct);
      thumb.alt = selectedProduct ? selectedProduct.title : '';
      info.appendChild(thumb);

      var textWrap = document.createElement('div');
      textWrap.className = 'elqora-combo-slot-text';

      var brandLine = document.createElement('div');
      brandLine.className = 'elqora-combo-slot-brand';
      brandLine.textContent = selectedProduct ? parseBrandLabel(selectedProduct.title) : '';
      textWrap.appendChild(brandLine);

      var shadeLine = document.createElement('div');
      shadeLine.className = 'elqora-combo-slot-shade';
      shadeLine.textContent = selectedProduct ? parseShadeLabel(selectedProduct.title) : '';
      textWrap.appendChild(shadeLine);

      info.appendChild(textWrap);
      slotEl.appendChild(info);

      var swatchGrid = document.createElement('div');
      swatchGrid.className = 'elqora-combo-swatch-grid';

      products.forEach(function (product, pIndex) {
        var swatch = document.createElement('button');
        swatch.type = 'button';
        swatch.className = 'elqora-combo-swatch' + (selections[slotIndex] === pIndex ? ' is-selected' : '');
        var shadeName = parseShadeLabel(product.title);
        swatch.setAttribute('aria-label', shadeName);
        swatch.title = shadeName;

        var img = document.createElement('img');
        img.src = getProductSwatchImage(product);
        img.alt = shadeName;
        img.loading = 'lazy';
        swatch.appendChild(img);

        swatch.addEventListener('click', function () {
          selections[slotIndex] = pIndex;
          renderAll();
          activateGalleryThumb(product);
        });

        swatchGrid.appendChild(swatch);
      });

      slotEl.appendChild(swatchGrid);
      return slotEl;
    }

    function updateAddButton() {
      addBtn.disabled = false;
      addBtn.textContent = 'Add to Cart — Rs. ' + Number(comboPrice).toFixed(0);
    }

    function renderAll() {
      slotsWrap.innerHTML = '';
      for (var i = 0; i < slotCount; i++) {
        slotsWrap.appendChild(renderSlot(i));
      }
      updateAddButton();
    }

    addBtn.addEventListener('click', function () {
      errorEl.classList.remove('is-visible');

      var items = [];
      var parseError = false;

      selections.forEach(function (slotIndex) {
        var product = products[slotIndex];
        if (!product) return;

        var rawVariantId = null;
        if (product.variants && product.variants.length) {
          rawVariantId = product.variants[0].id || product.variants[0];
        } else {
          rawVariantId = product.id;
        }

        var cleanIdStr = String(rawVariantId).replace(/\D/g, '');
        var parsedVariantId = parseInt(cleanIdStr, 10);

        if (!parsedVariantId || isNaN(parsedVariantId)) {
          parseError = true;
          return;
        }

        items.push({
          id: parsedVariantId,
          quantity: 1,
          properties: { _combo_set: offerTitle }
        });
      });

      if (parseError || items.length !== slotCount) {
        errorEl.textContent = 'One or more items could not be validated for checkout.';
        errorEl.classList.add('is-visible');
        return;
      }

      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (errData) {
              throw new Error(errData.description || 'Cart add failed.');
            });
          }
          return res.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) {
          errorEl.textContent = err.message || 'Error adding items to cart.';
          errorEl.classList.add('is-visible');
          updateAddButton();
        });
    });

    renderAll();
    container.innerHTML = '';
    container.appendChild(wrap);
  }
})();